@if (editType() !== EditType.DELETE) {
  <app-modal
          title="{{ editType() === EditType.CREATE ? 'Create' : 'Edit' }} availability for {{ dayOfWeek() | lowercase }}"
          #modalComponent>
    <p>The change will take effect starting from {{ startDate() }}</p>
    <form (ngSubmit)="onSubmit(modalComponent)" class="p-3">
      <div class="row">
        <div class="col">
          <label for="startTime">Start time</label>
          <ngb-timepicker
                  id="startTime"
                  [minuteStep]="15"
                  [formField]="availabilityForm.startTime">
          </ngb-timepicker>
          <div class="ms-4">
            <input class="form-check-input"
                   id="use-opening-time"
                   type="checkbox"
                   [formField]="availabilityForm.useOpeningTime"
                   (change)="toggleUseShopOpeningTime()">
            <label class="form-check-label use-opening-time-label" for="use-opening-time">Use shop opening time</label>
          </div>
          @if (availabilityForm.startTime().invalid() && availabilityForm.startTime().touched()) {
            <div class="form-error-message">
              @if (availabilityForm.startTime().errors()?.kind === 'required') {
                <p>Start time is required</p>
              } @if (availabilityForm.startTime().errors()?.kind === 'pattern') {
              <p>Start time must be in 15 minutes increments</p>
            }
            </div>
          }
        </div>
        <div class="col">
          <label for="endTime">End time</label>
          <ngb-timepicker
                  id="endTime"
                  [minuteStep]="15"
                  [formField]="availabilityForm.endTime">
          </ngb-timepicker>
          <div class="ms-4">
            <input class="form-check-input"
                   id="use-closing-time"
                   type="checkbox"
                   [formField]="availabilityForm.useClosingTime"
                   (change)="toggleUseShopClosingTime()">
            <label class="form-check-label use-closing-time-label" for="use-closing-time">Use shop closing time</label>
          </div>
          @if (availabilityForm.endTime().invalid() && availabilityForm.endTime().touched()) {
            <div class="form-error-message">
              @if (availabilityForm.endTime().errors()?.kind === 'required') {
                <p>End time is required</p>
              } @if (availabilityForm.endTime().errors()?.kind === 'pattern') {
              <p>End time must be in 15 minutes increments</p>
            }
            </div>
          }
        </div>
      </div>
      @if (availabilityForm.endTime().errors()?.kind === 'startTimeIsAfterEndTime') {
        <div class="form-error-message">
          <p>Start time must be earlier than end time</p>
        </div>
      } @if (availabilityForm.endTime().errors()?.kind === 'tooShortShift') {
      <div class="form-error-message">
        <p>The duration is too short</p>
      </div>
    }
      <div class="mt-4 text-end">
        <button class="btn btn-primary-outline btn-form me-3 close-button" type="button"
                (click)="modalComponent.activeModal.close()">Close
        </button>
        <button
                class="btn btn-primary btn-form save-button"
                type="submit"
                [disabled]="availabilityForm().invalid() || loading()">Save
        </button>
      </div>
    </form>
  </app-modal>
} @if (editType() === EditType.DELETE) {
  <app-modal title="Delete Availability"
             #modalComponent>
    <div class="confirmation-text">
      Do you really want to delete availability for {{ dayOfWeek() | enumParse }} starting
      from {{ startDate() }}?
    </div>
    <div class="mt-4 text-end">
      <button class="btn btn-primary-outline btn-form me-3 close-button" type="button"
              (click)="modalComponent.activeModal.close()">
        Close
      </button>
      <button class="btn btn-danger btn-form" type="button" (click)="onSubmit(modalComponent)" [disabled]="loading()">
        Delete
      </button>
    </div>
  </app-modal>
}